<template>
  <HKLLeftRight v-if="isSuccess && !isStarted && canStart">
    <template #right>
      <HKLButton
        color="orange"
        @click="start"
      >
        {{ $t('tenancy.greenOperation.start') }}
      </HKLButton>
    </template>
  </HKLLeftRight>
</template>

<script>
import HKLButton from '@/controls/Button/HKLButton'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight'
import { useGreenOperation, useGreenOperationPerms } from './hook'
import { useGreenOperationSppStatus } from './GreenOperationSpp.hook'
import { createGreenOperation } from '@/api/tenancies/GreenOperation.request'
import { useRouteParamId } from '@/router/useRouter'
import { unref } from 'vue-demi'

export default {
  components: {
    HKLLeftRight,
    HKLButton,
  },
  setup () {
    const tenancyId = useRouteParamId()
    const { refresh, isSuccess } = useGreenOperation()
    const { isStarted } = useGreenOperationSppStatus()
    const { canStart } = useGreenOperationPerms()
    return {
      isStarted,
      isSuccess,
      canStart,
      start: async () => {
        if (unref(isStarted)) return
        await createGreenOperation(unref(tenancyId))
        await refresh()
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.hkl-left-right {
  margin-bottom: 10px;
}
</style>
